<template>
  <narrow-container>
    <full-view-spinner :show="subscriberInProgress" />
    <h1 class="headline-secondary text--center">
      {{ this.$i18n.t('MANAGE.HEADER') }}
    </h1>
    <div v-if="subscriberData">
      <div class="padding-bot">
        <block-text
          :label="$i18n.t('MANAGE.LOGIN')"
          :value="subscriberData.msisdn"
        />
        <block-text
          :label="$i18n.t('MANAGE.SUBSCRIBER_DATA.STATUS')"
          :value="cardStatus"
        />
        <block-text
          :label="$i18n.t('MANAGE.SUBSCRIBER_DATA.CREDIT')"
          :value="formatEuroValue(subscriberData.accountBalance)"
        />
        <block-text
          :label="$i18n.t('MANAGE.SUBSCRIBER_DATA.AUTOTOPUP_STATUS')"
          :value="autotopupStatus"
        />
        <list-link
          v-if="showActivateAutoTopup"
          to="topUp"
          :label="this.$i18n.t('MANAGE.TO_AUTOTOPUP')"
        />
        <block-text-tariff
          :tariff-name="subscriberData.tariffSizeInfo.name"
          :tariff-price="formatEuroValue(subscriberData.tariffSizeInfo.priceGross)"
          :tariff-expiration-date="formatDateStringToDate(subscriberData.expirationDate)"
          :tariff-description="subscriberData.tariffSizeInfo.description"
          :tariff-legal-text="subscriberData.tariffSizeInfo.legalText"
        />
      </div>
    </div>
    <invoice-checkbox />
    <br>
    <list-link
      to="invoices"
      :label="this.$i18n.t('MANAGE.TO_INVOICES')"
    />
    <download-links />
  </narrow-container>
</template>

<script>
import AutotopupConstants from '@/constants/autotopupConstants.js';
import BlockText from '@/components/block-text/BlockText';
import BlockTextTariff from '@/components/block-text/BlockTextTariff';
import DownloadLinks from '@/views/manage/DownloadLinks';
import InvoiceCheckbox from '@/views/manage/InvoiceCheckbox.vue';

  export default {
    name: 'Manage',
    components: { BlockText, BlockTextTariff, DownloadLinks, InvoiceCheckbox },
    computed: {
      subscriberInProgress: function() {
        return this.$store.getters['subscriber/inProgress'];
      },
      subscriberData: function() {
        return this.$store.getters['subscriber/subscriberData'];
      },
      showActivateAutoTopup: function () {
        if (this.subscriberData) {
          return this.subscriberData.autoTopUpStatus == AutotopupConstants.AUTO_TOPUP_STATUS_NOT_ACTIVE;
        } else {
          return false;
        }
      },
      cardStatus: function() {
        if(this.subscriberData.dreiTvKarteActive) {
          return this.$i18n.t('MANAGE.SUBSCRIBER_DATA.ACTIVE');
        } else {
          return this.$i18n.t('MANAGE.SUBSCRIBER_DATA.NOT_ACTIVE');
        }
      },
      autotopupStatus: function() {
        if(this.subscriberData.autoTopUpStatus === AutotopupConstants.AUTO_TOPUP_STATUS_ACTIVE_SEPA
          || this.subscriberData.autoTopUpStatus === AutotopupConstants.AUTO_TOPUP_STATUS_ACTIVE_CREDIT_CARD) {
          return this.$i18n.t('MANAGE.SUBSCRIBER_DATA.ACTIVE');
        } else if (this.subscriberData.autoTopUpStatus === AutotopupConstants.AUTO_TOPUP_STATUS_NOT_ACTIVE) {
          return this.$i18n.t('MANAGE.SUBSCRIBER_DATA.NOT_ACTIVE');
        } else if (this.subscriberData.autoTopUpStatus === AutotopupConstants.AUTO_TOPUP_STATUS_NOT_POSSIBLE) {
          return this.$i18n.t('MANAGE.SUBSCRIBER_DATA.IN_PROGRESS');
        } else {
          return this.$i18n.t('MANAGE.SUBSCRIBER_DATA.FAILED');
        }
      },
    },
    mounted: function() {
      this.$store.dispatch("subscriber/refreshSubscriberData", this.$http);
    },
    methods: {
      formatDateStringToDate: function(input) {
        if (!input){
          return "-";
        }
        var date = new Date(input);
        return date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();
      },
      formatEuroValue: function(input) {
        return (Math.round(input * 100) / 100).toFixed(2).toString().replace(".", ",") + "	\u20AC"
      },
    },
  };
</script>

<style lang="scss" src="@/components/loading/loading.scss">
</style>
